import * as React from 'react';
import * as styles from './styles.css';

import { UIText1 } from '@cian/ui-kit';

import { IconActionChevronDown16 } from '@cian/ui-kit-design-tokens/icons';

interface ICollapsedProps {
  onClick(): void;
}

export const Collapsed: React.FC<ICollapsedProps> = ({ onClick }) => {
  return (
    <button data-testid="Collapsed" onClick={onClick} className={styles['button']}>
      <UIText1 color="text-main-default">Все сервисы</UIText1>
      <span className={styles['chevron']}>
        <IconActionChevronDown16 color="icon-main-default" />
      </span>
    </button>
  );
};

Collapsed.displayName = 'Collapsed';
